import $ from '../utils'
const sdkUri = "//cdn.jsdelivr.net/npm/leancloud-storage@3/dist/av-min.js";
let initialized = !1
export default (cfg,callback) => {
    if('AV' in window ) {
        let v = window['AV']['version'] || window['AV']['VERSION']
        if(parseInt(v.split('.')[0]) > 2) initialized = !!AV['applicationId'] && !!AV['applicationKey']
        else $.deleteInWin('AV', 0)
    }
    if(initialized) callback && callback()
    else $.sdkLoader(sdkUri,'AV',e=>{
        let prefix = 'https://',
            serverURLs = '',
            id = cfg['app_id'] || cfg['appId'],
            key = cfg['app_key'] || cfg['appKey'];
        if(!cfg['serverURLs']){
            switch (id.slice(-9)) {
                // TAB 
                case '-9Nh9j0Va':
                    prefix += 'tab.';
                    break;
                // US
                case '-MdYXbMMI':
                    prefix += 'us.';
                    break;
                default:
                    break;
            }
        }
        serverURLs = cfg['serverURLs'] || prefix + 'avoscloud.com';
        AV.init({
            appId: id,
            appKey: key,
            serverURLs: serverURLs,
        });
        initialized = !0
        callback && callback()
    })
}
